/**
 * Websocket event service
 */
export class WebsocketEventService {
  /**
   * Listen for an event
   *
   * @param {Socket} socket
   * @param {object} event
   * @param {string} event.name Event name
   * @param {string} [event.room] Event room
   * @param {(...args) => void} onEvent
   * @returns {(...args) => void} listener Event listener
   */
  on (socket, event, onEvent) {
    if (event.room) socket.emit('join', { room: event.room })
    socket.on(event.name, (...args) => {
      if (event.room) {
        const room = args.shift()
        if (event.room === room) {
          return onEvent(...args)
        }
        return null
      }

      return onEvent(...args)
    })
  }

  /**
   * Stop listening for an event
   *
   * @param {Socket} socket Socket
   * @param {object} event
   * @param {string} event.name Event name
   * @param {string} [event.room] Event room
   * @param {(...args) => void} onEvent
   */
  off (socket, event, onEvent) {
    socket.off(event.name, onEvent)
    if (event.room) socket.emit('leave', { room: event.room })
  }
}

export const websocketEventService = new WebsocketEventService()
